import React, { useState, useEffect } from "react";
import logo from '../assets/images/logo.svg'
import { auth } from '../firebase/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

export default function Login({ setLoggedIn }) {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')

    const handleLogin = async (e) => {
        if (email && password) {
            e.preventDefault(); // Prevent the default form submission behavior
            setError('');

            try {
                await signInWithEmailAndPassword(auth, email, password);
                setLoggedIn(true); // Update the parent component's state
                // alert('Login successful!');
            } catch (err) {
                // console.error("Login error: ", err.message);
                setError('Invalid email or password. Please try again.');
            }
        }
    };
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100vw',
            height: '100vh',
        }}>
            {error && (
                <p
                    style={{
                        color: '#d00',
                        textAlign: 'center',
                        marginTop: '10px',
                        fontSize: '16pt',
                        backgroundColor: '#f5ec8b',
                        fontWeight: 'bold',
                        fontFamily: 'Arial',
                        padding: '10px 20px',
                        borderRadius: '8px',
                        border: '2px solid #D0A847',
                        position: 'absolute',
                        top: '120px'
                    }}
                >
                    {error}
                </p>
            )}
            <form onSubmit={handleLogin} style={{
                width: '500px',
                height: '400px',
                backgroundColor: 'white',
                border: '2px solid #D0A847',
                boxShadow: '0px 0px 5px 2px #D0A847 inset',
                borderRadius: '10px',
                display: 'flex',
                // alignItems: 'center',
                flexDirection: 'column',
                padding: '30px 50px',
                gap: '20px'
            }}>
                {/* <h1 style={{
                    fontSize: '40pt',
                    textAlign: 'center',
                    fontWeight: '900',
                    fontFamily: 'Arial',
                    textTransform: 'uppercase',
                    letterSpacing: '5px'
                }}>IGT</h1> */}
                <img src={logo} alt="" style={{
                    height: '100px',
                    margin: 'auto'
                }} />
                <input type="email" placeholder="Enter your email" style={{
                    padding: '5px 15px',
                    fontSize: '16pt',
                    outline: 'none',
                    border: '1px solid #D0A847',
                    fontFamily: 'Arial',
                    borderRadius: '5px'
                }} onChange={(e) => setEmail(e.target.value)} value={email} required />
                <input type="password" placeholder="Enter your password" style={{
                    padding: '5px 15px',
                    fontSize: '16pt',
                    outline: 'none',
                    border: '1px solid #D0A847',
                    fontFamily: 'Arial',
                    borderRadius: '5px'
                }} onChange={(e) => setPassword(e.target.value)} value={password} required />
                <input type="submit" style={{
                    display: 'block',
                    cursor: 'pointer',
                    padding: '5px',
                    fontSize: '20pt',
                    outline: 'none',
                    border: '1px solid #D0A847',
                    boxShadow: '0px 0px 5px -2px gray',
                    backgroundColor: '#D0A847',
                    color: 'white',
                    borderRadius: '5px',
                    fontWeight: 'bold',
                    fontFamily: 'Arial',
                    textAlign: 'center'
                }} onClick={handleLogin} value='Login' />
            </form>
        </div>
    )
}